import React, { useEffect, useState } from 'react'
import { Card, Button, Modal, InputNumber, Row, Col } from 'antd';
import { PlusOutlined, PrinterOutlined, EditOutlined } from '@ant-design/icons';
import { Form, Input, TimePicker } from 'antd';
import locale from 'antd/es/date-picker/locale/es_ES';
import { getData, IMAGE_API, pre_colors, sendDataBody, usuario } from '../../resources';
import HojaDocument from './printed-docs/hojaEnfermeriaPrint';
import HojaEnfermeriaEditModal from './hojaEnfermeriaEditModal';


// FATHER: Expedientes

export default function HojasEnfermeriaNext({ id_paciente, hojas_enfermeria, id_nota, datosPaciente }) {

    const medicoTratante = datosPaciente?.medicos_asignados?.[0]?.name ?? '';

    // INITIAL HOJAS
    const [hojasData, setHojasData] = useState([])
    useEffect(() => {
        getHojas()
    }, [])
    const getHojas = () => {
        getData(`hojas/${id_paciente}`).then(setHojasData)
    }


    // Hoja for Edit / Details
    const [hojaEdit, setHojaEdit] = useState(null)

    // Modal for details
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false)
    const handleDetailsOk = () => { setIsDetailModalOpen(false); setHojaEdit(null) };
    const handleDetailsCancel = () => { setHojaEdit(null); setIsDetailModalOpen(false) };
    const gridStyle = { width: '14%', textAlign: 'center', height: '40' }
    // End Modal for details



    // Print Receta Modal
    const [isPrintingModalVisible, setIsPrintingModalVisible] = useState(false)
    const handlePrintOk = () => { setIsPrintingModalVisible(false); setIsLogoSelected(false) };
    const handlePrintCancel = () => { setIsPrintingModalVisible(false); setIsLogoSelected(false) };
    // Select logo for print in receta. Switches the modal view into select logo hospital/pdf recipe for print
    const [logoHospital, setLogoHospital] = useState(null)
    const [nombreHospital, setNombreHospital] = useState(null)
    const [isLogoSelected, setIsLogoSelected] = useState(false)



    // MODAL FOR ADD HOJA
    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    const onFinishCreateHojaEnfermeria = (values) => {
        values.id_paciente = id_paciente;
        values.medico_tratante = medicoTratante;
        sendDataBody('hojas/add', values).then(getHojas)
        console.log('New Hoka: ', values)
        handleCancel()

    };
    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    }
    // end MODAL FOR ADD HOJA


    // Print Receta
    const printHoja = async (r) => {
        setHojaEdit(r)
        setIsPrintingModalVisible(true)

    }


    useEffect(() => {
      console.log('DatosPaciente ', datosPaciente)
     
    }, [])
    
    return (
        <Card style={{ marginTop: 8 }}>
            <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                <h5>Hojas de Enfermería</h5>
                <Button onClick={showModal} type='primary' shape='round' size='small' ghost icon={<PlusOutlined />}>
                    Nueva hoja
                </Button>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 2, marginTop: 8 }}>
                {hojasData.length === 0 && (
                    <p style={{ color: '#bbb', fontSize: 13, margin: 0 }}>Sin hojas registradas</p>
                )}
                {hojasData.map((hoja, i) => {
                    hoja.aplicacion = i;
                    return (
                        <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '5px 0', borderBottom: i < hojasData.length - 1 ? '1px solid #f0f0f0' : 'none' }}>
                            <span style={{ cursor: 'pointer', color: '#0d6294', fontSize: 13 }} onClick={() => { setHojaEdit(hoja); setIsDetailModalOpen(true) }}>
                                Apl. {i + 1} · {new Date(hoja.inicio?.hora).toLocaleDateString('es-MX')}
                            </span>
                            <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                                <HojaEnfermeriaEditModal hoja_inicial={hoja} getHojaNueva={getHojas} medicoTratante={medicoTratante} />
                                <Button onClick={() => printHoja(hoja)} size='small' type="primary" shape="circle" icon={<PrinterOutlined />} className='btnIconCentered' ghost />
                            </div>
                        </div>
                    )
                })}
            </div>



            <Modal
                title="Nueva hoja de enfermería"
                closable={{ 'aria-label': 'Custom Close Button' }}
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                width={1000}
                footer={[
                    <Button onClick={handleOk}>Cerrar</Button>,
                    <Button type="primary" htmlType="submit" form='add_hoja_enfermeria'>
                        Guardar
                    </Button>
                ]} destroyOnClose
            >
                <Form
                    name="add_hoja_enfermeria"
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    // style={{ maxWidth: 600 }}
                    initialValues={{ remember: true }}
                    onFinish={onFinishCreateHojaEnfermeria}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                    layout='vertical'
                >

                    <div style={{ display: 'flex', gap: 8 }}>
                        <div style={{ width: '32%' }}>
                            <Form.Item label="Peso (kg)" name="peso" rules={[{ required: true, message: 'Ingresa el peso' }]}>
                                <InputNumber style={{ width: '100%' }} />
                            </Form.Item>
                        </div>
                        <div style={{ width: '32%' }}>
                            <Form.Item label="IMC" name="imc">
                                <InputNumber style={{ width: '100%' }} />
                            </Form.Item>
                        </div>
                        <div style={{ width: '32%' }}>
                            <Form.Item label="Dosis" name="dosis" rules={[{ required: true, message: 'Ingresa la dosis' }]}>
                                <Input />
                            </Form.Item>
                        </div>
                    </div>

                    <div style={{ display: 'flex', gap: 8 }}>
                        <div style={{ width: '32%' }}>
                            <Form.Item label="Hora de Inicio" name="hora_inicio" rules={[{ required: true }]}>
                                <TimePicker format='HH:mm' placeholder='Hora de inicio' locale={locale} style={{ width: '100%' }} />
                            </Form.Item>
                        </div>
                        <div style={{ width: '32%' }}>
                            <Form.Item label="Hora de Término" name="hora_termino" rules={[{ required: true }]}>
                                <TimePicker format='HH:mm' placeholder='Hora de término' locale={locale} style={{ width: '100%' }} />
                            </Form.Item>
                        </div>
                        <div style={{ width: '32%' }}>
                            <Form.Item label="Médico Tratante" >
                                <Input value={medicoTratante} disabled />
                            </Form.Item>
                        </div>
                    </div>

                    <div className='fila'>
                        <span style={{ width: 100 }}>INICIO</span>
                        <Form.Item label='Hora' name={['inicio', 'hora']} rules={[{ required: true }]} >
                            <TimePicker format='HH:mm' placeholder='Hora' locale={locale} />
                        </Form.Item>
                        <Form.Item label='Temp.' name={['inicio', 'temperatura']} rules={[{ required: true }]}>
                            <InputNumber />
                        </Form.Item>
                        <Form.Item label='Frec. Cardiaca' name={['inicio', 'frecuencia_cardiaca']} rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                        <Form.Item label='Frec. Respiratoria' name={['inicio', 'frecuencia_respiratoria']} rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                        <Form.Item label='P. Arterial' name={['inicio', 'presion_arterial']} rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                        <Form.Item label='Sat O₂' name={['inicio', 'saturacion_oxigeno']} rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                    </div>

                    <div className='fila'>
                        <span style={{ width: 100 }}>INTERMEDIO</span>
                        <Form.Item label='Hora' name={['intermedio', 'hora']} rules={[{ required: true }]} >
                            <TimePicker format='HH:mm' placeholder='Hora' locale={locale} />
                        </Form.Item>
                        <Form.Item label='Temp.' name={['intermedio', 'temperatura']} rules={[{ required: true }]}>
                            <InputNumber />
                        </Form.Item>
                        <Form.Item label='Frec. Cardiaca' name={['intermedio', 'frecuencia_cardiaca']} rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                        <Form.Item label='Frec. Respiratoria' name={['intermedio', 'frecuencia_respiratoria']} rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                        <Form.Item label='P. Arterial' name={['intermedio', 'presion_arterial']} rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                        <Form.Item label='Sat O₂' name={['intermedio', 'saturacion_oxigeno']} rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                    </div>

                    <div className='fila'>
                        <span style={{ width: 100 }}>TÉRMINO</span>
                        <Form.Item label='Hora' name={['termino', 'hora']} rules={[{ required: true }]} >
                            <TimePicker format='HH:mm' placeholder='Hora' locale={locale} />
                        </Form.Item>
                        <Form.Item label='Temp.' name={['termino', 'temperatura']} rules={[{ required: true }]}>
                            <InputNumber />
                        </Form.Item>
                        <Form.Item label='Frec. Cardiaca' name={['termino', 'frecuencia_cardiaca']} rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                        <Form.Item label='Frec. Respiratoria' name={['termino', 'frecuencia_respiratoria']} rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                        <Form.Item label='P. Arterial' name={['termino', 'presion_arterial']} rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                        <Form.Item label='Sat O₂' name={['termino', 'saturacion_oxigeno']} rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                    </div>

                    <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 8 }}>
                        PROCEDIMIENTOS REALIZADOS, SIGNOS Y SÍNTOMAS (OBSERVACIONES DE ENFERMERÍA)
                    </div>
                    <div style={{ display: 'flex', gap: 8 }}>
                        <div style={{ flex: 1 }}>
                            <Form.Item
                                name="observaciones"
                                rules={[{ required: true, message: 'Ingresa las observaciones' }]}
                            >
                                <Input.TextArea rows={5} />
                            </Form.Item>
                        </div>
                        <div style={{ width: 200 }}>
                            <Form.Item label="PHQ-9" name="phq9">
                                <Input />
                            </Form.Item>
                            <Form.Item label="GAD-7" name="gad7">
                                <Input />
                            </Form.Item>
                            <Form.Item label="COLUMBIA" name="columbia">
                                <Input />
                            </Form.Item>
                        </div>
                    </div>

                </Form>
            </Modal>

            <Modal open={isDetailModalOpen} onOk={handleDetailsOk} onCancel={handleDetailsCancel} width={1100} footer={[
                <Button onClick={handleDetailsOk}>Cerrar</Button>
            ]}>
                {
                    hojaEdit && <div>
                        <div style={{ display: 'flex', flexDirection: 'row', gap: 32, fontSize: 15, fontWeight: '500', flexWrap: 'wrap' }}>
                            <span>Aplicación {hojaEdit.aplicacion + 1}</span>
                            <span>Peso: {hojaEdit.peso} kg</span>
                            {hojaEdit.imc && <span>IMC: {hojaEdit.imc}</span>}
                            <span>Dosis: {hojaEdit.dosis}</span>
                            <span>{new Date(hojaEdit.createdAt).toLocaleDateString('es-Mx')}</span>
                            {hojaEdit.medico_tratante && <span>Médico Tratante: {hojaEdit.medico_tratante}</span>}
                        </div>
                        {(hojaEdit.hora_inicio || hojaEdit.hora_termino) && <div style={{ display: 'flex', gap: 32, fontSize: 14, marginTop: 8 }}>
                            {hojaEdit.hora_inicio && <span>Hora de Inicio: {new Date(hojaEdit.hora_inicio).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' })}</span>}
                            {hojaEdit.hora_termino && <span>Hora de Término: {new Date(hojaEdit.hora_termino).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' })}</span>}
                        </div>}

                        <Card style={{ marginTop: 10 }} bordered={false}>
                            <Card.Grid style={gridStyle}></Card.Grid>
                            <Card.Grid style={gridStyle}>HORA</Card.Grid>
                            <Card.Grid style={gridStyle}>TEMPERATURA</Card.Grid>
                            <Card.Grid style={gridStyle}>FRECUENCIA CARDIACA</Card.Grid>
                            <Card.Grid style={gridStyle}>FRECUENCIA RESPIRATORIA</Card.Grid>
                            <Card.Grid style={gridStyle}>PRESIÓN ARTERIAL</Card.Grid>
                            <Card.Grid style={gridStyle}>SATURACION O₂</Card.Grid>

                            <Card.Grid style={gridStyle}>INICIO</Card.Grid>
                            <Card.Grid style={gridStyle}>{new Date(hojaEdit.inicio.hora).toLocaleTimeString()}</Card.Grid>
                            <Card.Grid style={gridStyle}>{hojaEdit.inicio.temperatura}</Card.Grid>
                            <Card.Grid style={gridStyle}>{hojaEdit.inicio.frecuencia_cardiaca}</Card.Grid>
                            <Card.Grid style={gridStyle}>{hojaEdit.inicio.frecuencia_respiratoria}</Card.Grid>
                            <Card.Grid style={gridStyle}>{hojaEdit.inicio.presion_arterial}</Card.Grid>
                            <Card.Grid style={gridStyle}>{hojaEdit.inicio.saturacion_oxigeno}</Card.Grid>

                            <Card.Grid style={gridStyle}>INTERMEDIO</Card.Grid>
                            <Card.Grid style={gridStyle}>{new Date(hojaEdit.intermedio.hora).toLocaleTimeString()}</Card.Grid>
                            <Card.Grid style={gridStyle}>{hojaEdit.intermedio.temperatura}</Card.Grid>
                            <Card.Grid style={gridStyle}>{hojaEdit.intermedio.frecuencia_cardiaca}</Card.Grid>
                            <Card.Grid style={gridStyle}>{hojaEdit.intermedio.frecuencia_respiratoria}</Card.Grid>
                            <Card.Grid style={gridStyle}>{hojaEdit.intermedio.presion_arterial}</Card.Grid>
                            <Card.Grid style={gridStyle}>{hojaEdit.intermedio.saturacion_oxigeno}</Card.Grid>

                            <Card.Grid style={gridStyle}>TERMINO</Card.Grid>
                            <Card.Grid style={gridStyle}>{new Date(hojaEdit.termino.hora).toLocaleTimeString()}</Card.Grid>
                            <Card.Grid style={gridStyle}>{hojaEdit.termino.temperatura}</Card.Grid>
                            <Card.Grid style={gridStyle}>{hojaEdit.termino.frecuencia_cardiaca}</Card.Grid>
                            <Card.Grid style={gridStyle}>{hojaEdit.termino.frecuencia_respiratoria}</Card.Grid>
                            <Card.Grid style={gridStyle}>{hojaEdit.termino.presion_arterial}</Card.Grid>
                            <Card.Grid style={gridStyle}>{hojaEdit.termino.saturacion_oxigeno}</Card.Grid>
                        </Card>

                        <div style={{ fontSize: 16, fontWeight: '500', marginTop: 8, marginBottom: 8 }}>
                            PROCEDIMIENTOS REALIZADOS, SIGNOS Y SÍNTOMAS (OBSERVACIONES DE ENFERMERÍA)
                        </div>

                        <div style={{ display: 'flex', gap: 16 }}>
                            <Card size='small' className='textArea' style={{ flex: 1 }}>
                                {hojaEdit.observaciones}
                            </Card>
                            <div style={{ width: 180 }}>
                                {hojaEdit.phq9 && <div style={{ marginBottom: 8 }}><strong>PHQ-9:</strong> {hojaEdit.phq9}</div>}
                                {hojaEdit.gad7 && <div style={{ marginBottom: 8 }}><strong>GAD-7:</strong> {hojaEdit.gad7}</div>}
                                {hojaEdit.columbia && <div style={{ marginBottom: 8 }}><strong>COLUMBIA:</strong> {hojaEdit.columbia}</div>}
                            </div>
                        </div>

                    </div>
                }

            </Modal>


            <Modal title="Imprimir Hoja de Enfermería" open={isPrintingModalVisible} onOk={handlePrintOk} onCancel={handlePrintCancel} width={600}
                footer={[
                    <Button onClick={handlePrintCancel}>Cancelar</Button>
                ]} destroyOnClose
            >
                {
                    isLogoSelected ? // Si ya hay logo seleccionado, se pasa a la receta y se muestra en pdf
                        <HojaDocument receta={hojaEdit} logoHospital={logoHospital} nombreHospital={nombreHospital} datosPaciente={datosPaciente} />
                        :
                        <div>
                            <Card title='Selecciona un hospital' bordered={false}>
                                {
                                    usuario.horarios.map((h) => {
                                        return <Card.Grid style={{ width: '100%' }} onClick={() => { console.log('sucursal serlected', h.sucursal); setLogoHospital(h.sucursal.logo); setNombreHospital(h.sucursal.nombre); setIsLogoSelected(true) }} key={h._id}>
                                            <Row align="middle">
                                                <Col span={6} offset={4}><img width={64} src={IMAGE_API + h.sucursal.logo} alt="Logo" /></Col>
                                                <Col span={10}>{h.sucursal.nombre} <br /> {h.horario} <br />{h.sucursal.logo}</Col>
                                            </Row>
                                        </Card.Grid>
                                    })
                                }
                            </Card>
                        </div>
                }
            </Modal>
        </Card>
    )
}
